import React from "react";
import { Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ResponsivePage } from "../../../components/desktopUi";
import { MenuCard, MenuGrid } from "../../../components/managementUi";
import { appImages } from "../../../assets/appicons";
import { EMP_BASE_PATH } from "../../../config";

// Khớp app: app/(feature)/management/staff/index.tsx
const StaffIndex = () => {
  const navigate = useNavigate();
  return (
    <ResponsivePage title="Quản lý nhân viên">
      <MenuGrid>
        <MenuCard
          icon={appImages.icon_khach_hang}
          label="Nhân viên"
          onClick={() => navigate(`${EMP_BASE_PATH}/quan-ly/nhan-vien/danh-sach`)}
        />
        <MenuCard
          icon={appImages.icon_QLNV}
          label="Khối"
          onClick={() => navigate(`${EMP_BASE_PATH}/bao-tri`)}
        />
        <MenuCard
          icon={appImages.icon_Du_an}
          label="Vùng"
          onClick={() => navigate(`${EMP_BASE_PATH}/bao-tri`)}
        />
      </MenuGrid>
    </ResponsivePage>
  );
};

export default StaffIndex;
